module.exports = __webpack_public_path__ + "img/ic-more.a4618eb8.svg";